import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { createLagan, getLagan, getLaganList, updateLagan } from "./api";

const initialState = {
  laganListData: [],
  laganData: [],
  fetchLoading: false,
  loading: false,
  error: null,
};

export const getLaganListAsync = createAsyncThunk(
  "lagan/getLaganList",
  async (_, thunkAPI) => {
    try {
      const data = await getLaganList();
      return data;
    } catch (err) {
      const errorData = err?.response?.data || {
        message: "Failed to fetch lagan",
      };
      return thunkAPI.rejectWithValue(errorData);
    }
  }
);

export const createLaganAsync = createAsyncThunk(
  "lagan/createLagan",
  async ({ createLaganValues }, thunkAPI) => {
    try {
      const data = await createLagan(createLaganValues);
      return data;
    } catch (err) {
      const errorData = err?.response?.data || {
        message: "Failed to create lagan",
      };
      return thunkAPI.rejectWithValue(errorData);
    }
  }
);

export const getLaganAsync = createAsyncThunk(
  "lagan/getLagan",
  async (_, thunkAPI) => {
    try {
      const data = await getLagan();
      return data;
    } catch (err) {
      const errorData = err?.response?.data || {
        message: "Failed to fetch lagan",
      };
      return thunkAPI.rejectWithValue(errorData);
    }
  }
);

export const updateLaganAsync = createAsyncThunk(
  "lagan/updateLagan",
  async ({ updateLaganValues }, thunkAPI) => {
    try {
      const data = await updateLagan(updateLaganValues);
      return data;
    } catch (err) {
      const errorData = err?.response?.data || {
        message: "Failed to update lagan",
      };
      return thunkAPI.rejectWithValue(errorData);
    }
  }
);

const samvatSlice = createSlice({
  name: "samvat",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLaganListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLaganListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.laganListData = action.payload.data.results;
      })
      .addCase(getLaganListAsync.rejected, (state, action) => {
        state.loading = false;
        const errorMessage =
          action.payload?.message ||
          action.error?.message ||
          "Failed to Fetch lagan";
        state.error = errorMessage;
        toast.error(errorMessage);
      })
      .addCase(getLaganAsync.pending, (state) => {
        state.fetchLoading = true;
        state.error = null;
      })
      .addCase(getLaganAsync.fulfilled, (state, action) => {
        state.fetchLoading = false;
        state.laganData = action.payload.data.results;
      })
      .addCase(getLaganAsync.rejected, (state, action) => {
        state.fetchLoading = false;
        const errorMessage =
          action.payload?.message ||
          action.error?.message ||
          "Failed to Fetch lagan";
        state.error = errorMessage;
        toast.error(errorMessage);
      })
      .addCase(createLaganAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createLaganAsync.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action.payload?.message);
        // state.laganListData = action.payload.data.results;
      })
      .addCase(createLaganAsync.rejected, (state, action) => {
        state.loading = false;
        const errorMessage =
          action.payload?.message ||
          action.error?.message ||
          "Failed to create lagan";
        state.error = errorMessage;
        toast.error(errorMessage);
      })
      .addCase(updateLaganAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateLaganAsync.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action.payload?.message);
        // state.laganListData = action.payload.data.results;
      })
      .addCase(updateLaganAsync.rejected, (state, action) => {
        state.loading = false;
        const errorMessage =
          action.payload?.message ||
          action.error?.message ||
          "Failed to update lagan";
        state.error = errorMessage;
        toast.error(errorMessage);
      });
  },
});

export default samvatSlice.reducer;
